import { EntrepreneurAnnounce9FormComponent } from "../../../components/SupportSystem/SupportForm/current/EntrepreneurAnnounce9FormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function EntrepreneurAnnounce9FormContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <EntrepreneurAnnounce9FormComponent/>
            <Footer />
        </div>        
    )
    
}